import { Button } from '../components/ui/button';
import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FaChessQueen } from 'react-icons/fa';
import { GoogleLogin } from '@react-oauth/google';
import { Helmet } from 'react-helmet';
import { useWoodpeckerAuth } from '../woodpecker/Woodpecker';
import './Openings.css';

export function OpeningSignIn() {
  const auth = useWoodpeckerAuth();
  if (auth.isAuthenticated) return null;
  return <section className="opening-panel opening-signin">
    <h2>Save your opening training</h2>
    <p>Sign in to keep your sets, cycles, and progress. Samples are available without an account.</p>
    <GoogleLogin onSuccess={auth.handleGoogleLoginSuccess} onError={auth.handleGoogleLoginError} />
    <Button variant="neutral" size="action" className="m-0 border-solid" onClick={auth.startLichessOAuth}>Continue with Lichess</Button>
  </section>;
}

export default function OpeningLayout() {
  const { pathname } = useLocation();
  return <div className="openings-page">
    <Helmet><title>Opening Sequence Training | Puzzlify</title></Helmet>
    <header className="openings-header px-4 py-5 sm:px-6">
      <Link to="/" className="openings-brand"><FaChessQueen aria-hidden="true" /> Puzzlify</Link>
    </header>
    <main className={`openings-content w-full${/^\/openings\/learn\/[^/]+\/?$/.test(pathname) ? ' openings-content--lesson' : ''}`}><Outlet /></main>
  </div>;
}
